// reducers/pubsub/remove.js

export function removeHasErrored(state = false, action) {
  switch (action.type) {
    case 'REMOVE_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function removeIsLoading(state = false, action) {
  switch (action.type) {
    case 'REMOVE_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function remove(state = [], action) {
  switch (action.type) {
    case 'REMOVE_FETCH_DATA_SUCCESS':
      return action.response;
    default:
      return state;
  }
}